import { useState } from "react";
import Reveal from "@/components/7fcc/Reveal";
import SectionHeader from "@/components/7fcc/SectionHeader";
import { HOME } from "@/data/homeContent";

// Daily Standard — toggle items, "X / N complete" counter, progress bar,
// completion message revealed only when every item is checked.
export default function DailyStandard() {
  const s = HOME.standard;
  const [checked, setChecked] = useState(() => s.items.map(() => false));
  const count = checked.filter(Boolean).length;
  const allDone = count === s.items.length;

  return (
    <section id="standards" className="bg-ink-900 px-6 py-16 md:py-24" data-testid="home-standard">
      <div className="mx-auto max-w-3xl">
        <SectionHeader center eyebrow={s.eyebrow} title={s.headline} support={s.support} testId="home-standard-heading" />
        <Reveal delay={0.15} className="mt-10">
          <div className="rounded-lg border border-line bg-ink-950/60 p-6 md:p-8" data-testid="standard-panel">
            <div className="flex items-center justify-between">
              <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-fg-dim">Daily Standard</span>
              <span className="font-display text-lg text-fg" data-testid="standard-counter">
                {count} / {s.items.length} {s.counterSuffix}
              </span>
            </div>
            <div className="mt-3 h-1 w-full overflow-hidden rounded-full bg-ink-800" data-testid="standard-progressbar">
              <div
                className="h-full rounded-full bg-brand transition-all duration-500"
                style={{ width: `${(count / s.items.length) * 100}%` }}
                data-testid="standard-progressbar-fill"
              />
            </div>
            <ul className="mt-4">
              {s.items.map((item, i) => (
                <li key={item} className="border-b border-line last:border-b-0">
                  <button
                    type="button"
                    onClick={() => setChecked((c) => c.map((v, j) => (j === i ? !v : v)))}
                    aria-pressed={checked[i]}
                    data-testid={`standard-item-${i + 1}`}
                    className="flex w-full items-center gap-4 py-4 text-left"
                  >
                    <span
                      className={`flex h-5 w-5 shrink-0 items-center justify-center rounded border transition-colors duration-200 ${
                        checked[i] ? "border-brand bg-brand text-white" : "border-line bg-ink-900"
                      }`}
                      aria-hidden="true"
                    >
                      {checked[i] && (
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                      )}
                    </span>
                    <span className={`text-sm transition-colors md:text-base ${checked[i] ? "text-fg-dim line-through" : "text-fg-muted"}`}>
                      {item}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
            {allDone && (
              <p className="mt-6 text-center text-sm text-brand-light md:text-base" data-testid="standard-complete">
                {s.closing}
              </p>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}